/*
 * File: ApptCard.js
 * Project: mp-mobile-app
 *
 * Created by Vamsi Sureddy
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Handles and styles list of details on the appointment card in the List view
 */
import React from "react";
import { observer } from "mobx-react";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Preferences from "services/preferences/Store";
import PropTypes from "prop-types";
import AppointmentColor from "../../../utils/AppointmentColor";
import { format } from "date-fns";
import { useStore } from "utils/useStore";

const styles = theme => ({
  root: {
    paddingTop: 0,
    paddingBottom: 0
  },
  card: {
    width: "100%",
    boxShadow: `0px 0px 0 ${theme.spacing(0.1)}px ${theme.palette.common.black}`
  },
  apptPatientDate: {
    fontWeight: 500,
    color: theme.palette.common.black,
    marginBottom: theme.spacing(-1)
  },
  apptDetails: {
    color: theme.palette.common.black
  }
});

const ApptCard = ({ classes, appt }) => {
  const preferencesStore = useStore(Preferences);

  let getTitle = () => {
    return (
      <Typography variant="h6" className={classes.apptPatientDate}>
        {appt.patientNameDisplay}
      </Typography>
    );
  };

  let getSubheader = () => {
    return (
      <Typography variant="h6" className={classes.apptPatientDate}>
        {format(appt.startTime, "h:mm a")} ({appt.length} min)
      </Typography>
    );
  };
  const provider = () => {
    if (appt.providerID <= 1) return "";
    return (
      <React.Fragment>
        <b>Provider:</b> {appt.providerName}
        <br />
      </React.Fragment>
    );
  };
  let showApptColors = preferencesStore.get("apptColors");
  let cardStyle = {};

  if (showApptColors)
    cardStyle = AppointmentColor.getColorStyle(appt.colors, 16);

  return (
    <Card style={cardStyle} className={classes.card}>
      <CardHeader title={getTitle()} subheader={getSubheader()} />
      <CardContent className={classes.root}>
        <Typography variant="subtitle1" className={classes.apptDetails}>
          {provider()}
          <b>Resource:</b> {appt.resource}
          <br />
          <b>Type:</b> {appt.type}
          <br />
          <b>Status:</b> {appt.status}
        </Typography>
      </CardContent>
    </Card>
  );
};

ApptCard.propTypes = {
  classes: PropTypes.object.isRequired,
  appt: PropTypes.object.isRequired
};

export default withStyles(styles)(observer(ApptCard));
